import React, { useEffect, useState } from "react";
import DashboardLayout from "../../../hocs/layout/DashboardLayout";
import { Link, useParams } from "react-router-dom";
import {
  search_entrada,
  search_entrada_page,
} from "../../../redux/actions/P03/p03";
import { connect } from "react-redux";
import EntradasListSearch from "../../../components/P03/entradas/EntradasListSearch";
import Toast from "../../../components/Alert";

function SearchEntradasP03({
  search_entrada,
  search_entrada_page,
  entrada,
  count,
}) {
  const params = useParams();
  const term_params = params.term;

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    search_entrada(term_params).finally(() => setLoading(false));
  }, [term_params]);

  const [planta, setPlanta] = useState("");
  const [plantamensual, setPlantaMensual] = useState("");
  const [mes, setMes] = useState("");
  const [año, setAño] = useState("");
  const [mostrarReporte, setMostrarReporte] = useState(false);

  const currentYear = new Date().getFullYear();
  const years = Array.from({ length: 10 }, (_, i) => currentYear - i);

  const handleChangePlanta = (e) => {
    setPlanta(e.target.value);
  };

  const handleChangePlantaMensual = (e) => {
    setPlantaMensual(e.target.value);
  };

  const handleChangeMes = (e) => {
    setMes(e.target.value);
  };

  const handleChangeAño = (e) => {
    setAño(e.target.value);
  };

  const handleReporteMensual = () => {
    if (plantamensual && mes && año) {
      alert(plantamensual, mes, año);
      setTimeout(
        () =>
          (window.location.href =
            "/entradas-p03/ver-mensual/" +
            plantamensual +
            "/" +
            mes +
            "/" +
            año),
        0.2
      );
    } else {
      Toast({
        tipo: "error",
        mensaje: "Debes seleccionar una planta, un mes y un año.",
      });
    }
  };

  const [term, setTerm] = useState("");
  const handleChange = (e) => {
    setTerm(e.target.value);
  };

  const onSubmit = (e) => {
    e.preventDefault();
    setTimeout(() => (window.location.href = "/entradas-p03/" + term), 0.2);
    setTerm("");
  };

  return (
    <DashboardLayout>
      <div className="border-b border-gray-200 py-5 sm:px-6">
        <div className="flex flex-col flex-wrap lg:flex-row lg:items-center justify-between sm:flex-nowrap">
          <div className="">
            <h3 className="text-2xl font-medium leading-6 text-gray-900">
              Lista de entradas de materiales e insumos Planta 03.
            </h3>
          </div>
          <div className="flex flex-col lg:flex-row lg:items-center gap-4 py-2 lg:py-0">
            <div className="flex justify-between gap-4">
              <Link to="/entradas-p03/form">
                <button className="bg-[#DC2917] text-white px-4 py-1.5 rounded hover:bg-red-800">
                  Agregar entrada
                </button>
              </Link>
            </div>
            <div className="">
              <div className="flex items-center md:max-w-3xl md:mx-auto lg:max-w-none">
                <form onSubmit={(e) => onSubmit(e)} className="w-full">
                  <label htmlFor="search" className="sr-only">
                    Search
                  </label>
                  <div className="relative">
                    <button
                      type="submit"
                      className="pointer-events-none absolute inset-y-0 left-0 pl-3 flex items-center"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        strokeWidth={1.5}
                        stroke="currentColor"
                        className="w-6 h-6"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607z"
                        />
                      </svg>
                    </button>
                    <input
                      id="search"
                      name="search"
                      required
                      onChange={(e) => {
                        handleChange(e);
                      }}
                      className="block w-full bg-white border border-gray-300 rounded-md py-2 pl-10 pr-3 text-sm placeholder-gray-500 focus:outline-none focus:text-gray-900 focus:placeholder-gray-400 focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                      placeholder="Buscar"
                      type="search"
                    />
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
        {mostrarReporte && (
          <div className="mt-4 flex gap-4">
            <div className="form-control">
              <label className="label">
                <span className="label-text">Planta</span>
              </label>
              <select
                onChange={handleChangePlantaMensual}
                value={plantamensual}
                className="select select-bordered"
              >
                <option value="">Elige una planta</option>
                <option value="1">Planta 01</option>
                <option value="2">Planta 02</option>
                <option value="3">Planta 03</option>
                <option value="4">Planta 04</option>
                <option value="5">Planta 05</option>
                <option value="Proveedores">Proveedor</option>
              </select>
            </div>
            <div className="form-control">
              <label className="label">
                <span className="label-text">Mes</span>
              </label>
              <select
                onChange={handleChangeMes}
                value={mes}
                className="select select-bordered"
              >
                <option value="">Elige un mes</option>
                <option value="1">Enero</option>
                <option value="2">Febrero</option>
                <option value="3">Marzo</option>
                <option value="4">Abril</option>
                <option value="5">Mayo</option>
                <option value="6">Junio</option>
                <option value="7">Julio</option>
                <option value="8">Agosto</option>
                <option value="9">Septiembre</option>
                <option value="10">Octubre</option>
                <option value="11">Noviembre</option>
                <option value="12">Diciembre</option>
              </select>
            </div>
            <div className="form-control">
              <label className="label">
                <span className="label-text">Año</span>
              </label>
              <select
                onChange={handleChangeAño}
                value={año}
                className="select select-bordered"
              >
                <option value="">Elige un año</option>
                {years.map((year) => (
                  <option key={year} value={year}>
                    {year}
                  </option>
                ))}
              </select>
            </div>
            <button
              onClick={handleReporteMensual}
              className={`bg-[#0096C4] text-white px-4 py-1.5 rounded hover:bg-[#007ca1] self-end ${
                !plantamensual || !mes || !año
                  ? "cursor-not-allowed opacity-50"
                  : ""
              }`}
              disabled={!plantamensual || !mes || !año}
            >
              Generar Reporte
            </button>
          </div>
        )}
      </div>
      {loading ? (
        <div className="flex items-center justify-center h-96">
          <div className="w-10 h-10 border-t-2 border-b-2 border-[#0096C4] rounded-full animate-spin"></div>
        </div>
      ) : entrada && entrada.length > 0 ? (
        <EntradasListSearch
          entradas={entrada}
          search_entrada_page={search_entrada_page}
          count={count}
          search_term={term_params}
        />
      ) : (
        <div className="flex items-center justify-center h-96">
          <p className="text-gray-500">No se encontraron resultados.</p>
        </div>
      )}
    </DashboardLayout>
  );
}

const mapStateToProps = (state) => ({
  entrada: state.entradas.entrada_filtrada,
  count: state.entradas.count,
});

export default connect(mapStateToProps, {
  search_entrada,
  search_entrada_page,
})(SearchEntradasP03);
